import SearchCard from './SearchCard';

export * from './SearchCard';

export default SearchCard;
